module.exports = __webpack_public_path__ + "img/article_ad_banner_01.b1b220c9.jpg";